import React from 'react';
import dayjs from 'dayjs';

//Estilos
import './DJCPPrint.css';
import logo from '../../assets/imgs/logo_inavi.png';
import { formatNumberLength } from '../../helpers';

function DJCPPrint({ functions, states, reference }) {
    const { formatNumber } = functions;

    const {
        masters,
        grapesVariety,
        DJCPData: { cabecera, items },
        Coordinates,
    } = states;

    const Titulares = cabecera?.titulares?.split('/');
    const TitularesDoc = cabecera?.titulares_Documento?.split('/');

    return (
        <div className="DJCPPrint-container">
            <div ref={reference} className="DJCPPrint-parent">
                <header className="DJCPPrint-header">
                    <img className="DJCPPrint-logo" src={logo} alt="INAVI" />
                    <div className="DJCPPrint-header-title">
                        <h2>DECLARACIÓN JURADA DE COSECHA PROBABLE DE UVA</h2>
                        <h3>(Ley Nº13.665 de 17-06-1968)</h3>
                    </div>
                    <h3>
                        {cabecera?.serie}-
                        {masters.LetterTypes?.find((lt) => lt.id === 4).nombre}-
                        {formatNumber(cabecera?.numero, 4)}
                    </h3>
                </header>
                <section className="DJCPPrint-info-section">
                    <table>
                        <tbody>
                            <tr>
                                <td>VIÑEDO: </td>
                                <td>{cabecera?.viniedo}</td>
                                <td>TELÉFONO: </td>
                                <td>{cabecera?.telefono}</td>
                            </tr>
                            {Titulares?.map((t, i) => {
                                return (
                                    <tr key={i}>
                                        <td>TITULAR: </td>
                                        <td>{t}</td>
                                        <td>DOCUMENTO: </td>
                                        <td>
                                            {TitularesDoc
                                                ? TitularesDoc[i]
                                                : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <section className="DJCPPrint-info-section">
                    <table>
                        <tbody>
                            <tr>
                                <td>FECHA: </td>
                                <td>
                                    {dayjs(cabecera?.fecha).format(
                                        'DD-MM-YYYY'
                                    )}
                                </td>

                                <td>TIMBRE: </td>
                                <td>{cabecera?.timbre ? 'PAGO' : 'NO PAGO'}</td>
                            </tr>
                            <tr>
                                <td>SUPERFICIE: </td>
                                <td>{cabecera?.total_Superficie} m²</td>
                                <td>PADRONES: </td>
                                <td>{cabecera?.padrones.replace('_', ', ')}</td>
                            </tr>
                            <tr>
                                <td>UBICACIÓN: </td>
                                <td>
                                    Lat: {formatNumberLength(Coordinates?.lat)},
                                    Long: {formatNumberLength(Coordinates?.lon)}
                                </td>
                                <td>DEPARTAMENTO: </td>
                                <td>{cabecera?.departamento}</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section className="DJCPPrint-production-section">
                    <h3>PRODUCCIÓN DE UVA</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Variedad</th>
                                <th>Superficie</th>
                                <th>Kilos Ingresados</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items?.map((it, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            {
                                                grapesVariety?.find(
                                                    (gv) =>
                                                        gv.codigo ===
                                                        it.variedad
                                                )?.variedad
                                            }
                                        </td>
                                        <td>{it.superficie} m²</td>
                                        <td>{it.kilos} kg</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <footer className="DJCPPrint-footer">
                    <label className="DJCPPrint-label">
                        <span>TOTAL KILOS DE PRODUCCIÓN: </span>
                        <p>{cabecera?.total_Kilos} kg</p>
                    </label>
                </footer>
            </div>
        </div>
    );
}

export default DJCPPrint;
